import React, { useState } from "react";
import ListingPlaceholder from "./ListingPlaceholder";

/**
 * Rendered een <img>, maar valt automatisch terug op de "Foto volgt"-placeholder
 * als de afbeelding niet geladen kan worden (bv. 404 na een verwijderd bestand).
 *
 * Waarom nodig?
 *  - Voorheen kwam een gebroken bestand ergens in /api/uploads/... door tot in de
 *    browser als een kapot img-icoontje. Sinds we naar duurzame opslag (GridFS)
 *    zijn gegaan zou dit niet meer moeten gebeuren — maar records uit een oude
 *    deploy kunnen nog verwijzen naar niet-bestaande files. Deze fallback maakt
 *    dat visueel netjes.
 */
export const ImageWithFallback = ({
  src,
  alt = "",
  className = "",
  loading = "lazy",
  placeholderLabel,
  placeholderClassName = "",
}) => {
  const [failed, setFailed] = useState(false);
  if (!src || failed) {
    return (
      <ListingPlaceholder
        label={placeholderLabel}
        className={placeholderClassName}
      />
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading={loading}
      onError={() => setFailed(true)}
    />
  );
};

export default ImageWithFallback;
